export const INITIAL = {
	MODAL: {
		content: '',
		data: {},
	},
	VALUES: {
		name: '',
		description: '',
		attribute: 'FOR',
		active: true,
		level: 1,
	},
	LIST: {
		columns: {
			name: 'Nome',
			description: 'Descrição',
			attribute: 'Atributo',
			level: 'Nível',
		},
		rows: []
	},
}